<div class="quick-actions-grid">
	@for (action of actions(); track action.label) {
		<a class="quick-action-tile"
			[routerLink]="action.routerLink"
			[queryParams]="action.queryParams"
			*ifHasPermission="{ requiredPermissions: action.permissions ?? [], userPermissionOnly: action.userPermissionOnly ?? false }">
			<fa-duotone-icon [icon]="action.icon" size="lg" secondaryOpacity="0.5" />
			<span class="quick-action-label">{{ action.label }}</span>
		</a>
	}
</div>
